const KEY = 'AIzaSyCOr2sJ-plmKOnAIMq8TYFmlahYiGBGjS4';
const CALLBACK_NAME = '__google_maps_init_callback__';

export default (callback) => {
  window[CALLBACK_NAME] = callback;

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = `https://maps.googleapis.com/maps/api/js?key=${KEY}&callback=${CALLBACK_NAME}`;
  document.body.appendChild(script);
};



// WEBPACK FOOTER //
// ./themes/app/assets/js/modules/loadMaps.js